import { InputProps } from './types'
import { PublicConsentField } from '@tm/shared-lib/src/field'
import { useConsentField, UseConsentProps } from '../../../ConsentField/useConsentField'
import { ConsentField } from '../../../ConsentField/ConsentField'

export function PublicConsentInput(props: InputProps<PublicConsentField> & UseConsentProps) {
  const { field, state, dispatch, validationErrors } = props
  const consentProps = useConsentField({ state, dispatch, validationErrors }, field.name)

  return <ConsentField {...consentProps} />
}
